import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function GuruQuote() {
  return <section className="py-24 bg-[#FAF7F2] relative overflow-hidden" data-id="element-157">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#8B9D83]/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-158" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-159" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-160">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-161">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-162">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-163">
              <img src="https://cdn.magicpatterns.com/uploads/qskW2iFM6XwGiJE6vd94d6/WhatsApp_Image_2025-12-29_at_21.53.44.jpg" alt="Tatwagyani Sumanand Sagar" className="w-full h-full object-cover" data-id="element-164" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-165" />
            </div>
            {/* Decorative border frame */}
            <div className="absolute -inset-4 border border-[#D4AF37]/30 rounded-2xl -z-10" data-id="element-166" />
          </motion.div>

          {/* Quote Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex flex-col justify-center" data-id="element-167">
            <Quote className="w-12 h-12 text-[#D4AF37] mb-6 opacity-80" data-id="element-168" />
            <blockquote className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#2C3E50] leading-tight mb-8" data-id="element-169">
              "True peace is not the absence of noise, but the presence of
              harmony within the soul. When you find the center, you find the
              universe."
            </blockquote>
            <div className="flex items-center gap-4" data-id="element-170">
              <div className="h-px w-12 bg-[#D4AF37]" data-id="element-171" />
              <div data-id="element-172">
                <cite className="not-italic font-serif text-xl font-bold text-[#2C3E50] block" data-id="element-173">
                  Tatwagyani Sumanand Sagar
                </cite>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}